import { PLANS_TO_NOT_SHOW_PATIENT_HOME_DISCLAIMER } from 'settings/_plansToNotShowPatientHomeDisclaimer'

export function shouldShowDisclaimerInPatientHome(patientPlanGroupCode: string): boolean {
  const isPatientPlanInExceptionList = PLANS_TO_NOT_SHOW_PATIENT_HOME_DISCLAIMER.includes(patientPlanGroupCode)

  return !isPatientPlanInExceptionList
}